import { useTranslation } from 'react-i18next'

import { Checkbox, ComboBox, InputWithLabel } from '@reveni-io/reveni-ui'

import { missingValueMessages } from '@/common/components/MatchTypeEditor/constants'
import { isBlankValue } from '@/common/components/MatchTypeEditor/helpers'

import * as Styles from './styles'

const SingleValueInput = ({
  value,
  onChange,
  matchCase,
  onChangeMatchCase,
  disabled,
  showCombo,
  comboItems,
  hasError,
  rejectsBlankValues,
  inputBackgroundColor,
}) => {
  const { t } = useTranslation()

  const isEmpty = rejectsBlankValues ? isBlankValue(value) : !value && value !== 0
  const missingValueMessage = rejectsBlankValues ? missingValueMessages.blank : missingValueMessages.empty
  const showError = hasError && isEmpty

  return (
    <Styles.Container>
      {showCombo ? (
        <ComboBox
          label={t('Valor')}
          menuItems={comboItems}
          handleChange={e => onChange(e.target.value)}
          value={value || ''}
          fullWidth
          disabled={disabled}
          backgroundColor={inputBackgroundColor}
          error={showError}
          helperText={showError ? t(missingValueMessage) : ' '}
        />
      ) : (
        <InputWithLabel
          label={t('Valor')}
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          fullWidth
          disabled={disabled}
          backgroundColor={inputBackgroundColor}
          error={showError}
          helperText={showError ? t(missingValueMessage) : undefined}
        />
      )}
      {!showCombo && (
        <Checkbox
          label={t('Distinguir mayúsculas y minúsculas')}
          checked={!!matchCase}
          onChange={e => onChangeMatchCase(e.target.checked)}
          disabled={disabled}
        />
      )}
    </Styles.Container>
  )
}

export default SingleValueInput
